import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import LayoutAsignacion from "../../components/layout-asignacion";
import AsignacionIndex from ".";
import AsignacionConfiguracionPage from "./configuracion";
import AsignacionPage from "./asignacion";

const RouterAsignacion = () => {
  const { path } = useRouteMatch();
  // console.log('RouterAsignacion');
  // console.log(path);
  return (
    <LayoutAsignacion>
      <Switch>

        <Route exact path={`${path}/asignacion`}>
          <AsignacionPage />
        </Route>

        <Route exact path={`${path}/principal`}>
          <AsignacionIndex />
        </Route>

        <Route path={`${path}/configuracion`}>
          <AsignacionConfiguracionPage />
        </Route>

        <Route exact path={`${path}`}>
          <AsignacionIndex />
        </Route>

      </Switch>
    </LayoutAsignacion>
  );
};

export default RouterAsignacion;
